// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"478":"a70586c2","637":"4dbc58e2","974":"1f923e52"}[chunkId] + ".chunk.css";
};